import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import EventEmitter from "../../../utils/emitter/EventEmitter";
import { EMITTER_SUCCESS, tempHeadCells } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";
import { filterQuery, getErrorMessage } from "../../../utils/helpers";
import { getRequest, postRequest } from "../../../Apis";
import { viewEndPoints } from "../../../utils/constants/httpConstants";
import { STRINGS } from "../strings";
import { Button } from "../../../components/Buttons";
import CustomModal from "../../../components/Modals/CustomModal";
import Typography from "../../../components/Typography/Typography";
import { GREY } from "../../../utils/constants/colors";
import { fontWeight } from "../../../utils/constants/UI";
import InputField from "../../../components/InputFields/InputField";
import RadioButton from "../../../components/RadioButton/RadioButton";
import Checkbox from "../../../components/Buttons/Checkbox/Checkbox";
import classes from "./LeadsComponent.module.css";
import { getPeopleBasicDetails } from "../../../redux/actions/peopleActions";
import { getCompanyBasicDetails } from "../../../redux/actions/companyActions";

const AddViewModal = ({
  open,
  setOpen,
  leadType = STRINGS.PEOPLE,
  isRename,
  setIsRename = () => { },
  renamePopupValue,
  setPublicViews = () => { },
  setPrivateViews = () => { },
  setTeamViews = () => { },
  setViewCardMenu = () => { },
  setPrivateViewCardMenu = () => { },
  getViews = () => { },
  viewType = "",
  setAllViewModalState = () => { }
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [viewName, setViewName] = useState(
    renamePopupValue?.eachView?.view_name || ""
  );
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPin, setIsPin] = useState(false);
  const [selectedValue, setSelectedValue] = React.useState();
  const allFilterSelector = useSelector((state) => state?.allFilters?.payload);
  const filtersQuery = filterQuery(allFilterSelector);

  const tableColumnsSelector = useSelector(
    (state) => state?.ApplyUpdateColumn?.columns
  );
  const peopleBasicDetailsSelector = useSelector((state) => state.peopleBasicDetails);
  const companyBasicDetailsSelector = useSelector((state) => state.companyBasicDetails);

  useEffect(() => {
    setViewName(renamePopupValue?.eachView?.view_name || "");
    setSelectedValue(renamePopupValue?.type || viewType || STRINGS.PRIVATE_ID);
    setIsPin(renamePopupValue?.eachView?.is_pin);
  }, [renamePopupValue]);

  const radioButtonData = [
    { id: STRINGS.PRIVATE_ID, label: STRINGS.PRIVATE_LABEL },
    { id: STRINGS.TEAM_ID, label: STRINGS.TEAM_LABEL },
  ];

  const tableColumns = tableColumnsSelector
    ?.filter((item) => item.isChecked)
    .map((item) => item.id);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleClose = () => {
    setIsRename(false);
    setOpen(!open);
    setErrMsg("");
    setViewName("");
    setSelectedValue("");

  };

  const handleCreate = async () => {
    const update_view_id = renamePopupValue?.eachView?.view_id || "";
    if (viewName?.length === 0) {
      setErrMsg(STRINGS.REQUIRED);
      return;
    }
    if (viewName?.length >= 50) {
      setErrMsg(STRINGS.VIEW_CANT_25CHAR);
      return;
    }

    setErrMsg("");
    const payload = {
      view_name: viewName,
      view_type: selectedValue,
      query_string: filtersQuery,
      is_pin: isPin ? 1 : 0,
      table_columns: tableColumns || [
        ...tempHeadCells
          .map((item) => item.id)
          .filter((item) => item.isChecked),
      ],
    };
    setLoading(true);
    try {
      let URL = "";
      if (leadType === STRINGS.PEOPLE) {
        if (update_view_id?.length) {
          URL = viewEndPoints.viewUpdate;
        } else {
          URL = viewEndPoints.createView;
        }
      } else {
        if (update_view_id?.length) {
          URL = viewEndPoints.CompanyViewUpdate;
        } else {
          URL = viewEndPoints.createCompanyView;
        }
      }

      if (update_view_id.length) {
        payload.view_id = update_view_id;
        delete payload?.query_string;
        delete payload?.table_columns;
      }

      const response = await postRequest(navigate, URL, payload);
      // if (isRename) {
      const URL1 =
        leadType === STRINGS.PEOPLE
          ? viewEndPoints.getAllView
          : viewEndPoints.getCompanyViews;
      const response1 = await getRequest(navigate, URL1);
      setPublicViews(response1?.data?.data?.public);
      setPrivateViews(response1?.data?.data?.private);
      setTeamViews(response1?.data?.data?.team);
      // }
      setViewCardMenu(null);
      setPrivateViewCardMenu(null);
      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);

      setOpen(false);
      setLoading(false);

      const active_view_id = sessionStorage.getItem(STRINGS.ACTIVE_VIEW_ID);
      const view_id = active_view_id
        ? `?${STRINGS.VIEW_ID}=${active_view_id}`
        : payload?.default_view?.is_main_view
          ? `?${STRINGS.VIEW_ID}=${payload?.default_view?.view_id}`
          : payload?.default_view?.view_id
            ? `?${STRINGS.VIEW_ID}=${payload?.default_view?.view_id}`
            : "";
      leadType === STRINGS.PEOPLE ? dispatch(getPeopleBasicDetails(navigate, view_id)) : dispatch(getCompanyBasicDetails(navigate, view_id));

      getViews();
      setViewName("");
      setSelectedValue("");
    } catch (error) {
      setLoading(false);
      console.log("Error---------->>>>>>>>>> ", error);
      setErrMsg(
        getErrorMessage(error?.data?.data?.errors || {}, error?.data?.message)
      );
    }
  };

  const modalHeaderData = {
    heading: {
      id: STRINGS.HEADER_ID,
      label: isRename ? STRINGS.EDIT_VIEW : STRINGS.CREATE_NEW_VIEW,
    },
  };

  const modalBodyData = (
    <div className={classes.bodyContainerView}>
      <Box className={classes.containInput}>
        <Typography
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.MEDIUM}
          label={STRINGS.VIEW_NAME}
        />

        <InputField
          placeholder={STRINGS.WRITE_VIEW_NAME}
          value={viewName}
          size={"sm36"}
          onChange={(e) => setViewName(e.target.value)}
          variant={errMsg?.length ? STRINGS.ERROR : STRINGS.DEFAULT}
          errormessage={errMsg}
        />
      </Box>

      <Box className={classes.sharedWithBox}>
        <Typography
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.MEDIUM}
          label={STRINGS.SHARED}
        />
        <Box className={classes.containRadioBtns}>
          <Box className={classes.eachRadioContainer}>
            <RadioButton
              value={selectedValue}
              onChange={handleChange}
              items={radioButtonData}
            />
          </Box>
        </Box>
      </Box>
    </div>
  );

  const modalFooterRightData = (
    <div className={classes.modalFooterRightData}>
      <Button
        label={STRINGS.CANCEL}
        size={"sm36"}
        variant={"ghost"}
        onClick={handleClose}
      />

      <Button
        label={isRename ? STRINGS.UPDATE : STRINGS.SAVE}
        size={"sm36"}
        variant={"primary"}
        onClick={() => {
          handleCreate();
        }}
        isLoading={loading}
      />
    </div>
  );

  const modalFooterLeftData = (
    <div className={classes.modalFooterLeftContainer}>
      <Checkbox
        label={STRINGS.PIN_THIS_VIEW}
        checked={isPin}
        onChange={() => setIsPin(!isPin)}
      />
    </div>
  );

  return (
    <CustomModal
      close={handleClose}
      open={open}
      header={modalHeaderData}
      children={modalBodyData}
      footer={{
        left: (renamePopupValue?.eachView?.view_id === peopleBasicDetailsSelector?.payload?.default_view?.view_id || renamePopupValue?.eachView?.view_id === companyBasicDetailsSelector?.payload?.default_view?.view_id) ? <div></div> : modalFooterLeftData,
        right: modalFooterRightData,
      }}
    />
  );
};

export default AddViewModal;
